
import { useState } from 'react';
import { services } from '../../../mocks/services';

export default function Services() {
  const [showLandscapingMenu, setShowLandscapingMenu] = useState(false);

  const landscapingServices = [
    { name: 'Rock Installation', icon: 'ri-stack-line' },
    { name: 'Mulch Spreading', icon: 'ri-leaf-line' },
    { name: 'Plant Flowers/Bushes', icon: 'ri-plant-line' }
  ];

  return (
    <section id="services" className="py-24 bg-gray-50">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-5xl font-bold text-gray-900 mb-4">Our Services</h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            From painting to landscaping, we offer comprehensive services to enhance your property's beauty and value.
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
          {services.map((service, index) => (
            <div 
              key={index}
              className="bg-white rounded-xl overflow-hidden shadow-sm hover:shadow-lg transition-shadow cursor-pointer"
            >
              <div className="h-48 w-full overflow-hidden">
                <img 
                  src={service.image} 
                  alt={service.name}
                  className="w-full h-full object-cover object-top hover:scale-105 transition-transform duration-300"
                />
              </div>
              <div className="p-6">
                <div className="text-xs font-semibold text-teal-600 mb-2 uppercase tracking-wide">
                  {service.category}
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-3">
                  {service.name}
                </h3>
                <p className="text-gray-600 text-sm mb-4 leading-relaxed">
                  {service.description}
                </p>
                
                {service.name === 'Landscaping' && (
                  <div className="relative">
                    <button 
                      onClick={() => setShowLandscapingMenu(!showLandscapingMenu)}
                      className="text-teal-600 font-semibold text-sm hover:text-teal-700 transition-colors whitespace-nowrap cursor-pointer flex items-center gap-1"
                    >
                      Learn More 
                      <i className={`ri-arrow-down-s-line transition-transform ${showLandscapingMenu ? 'rotate-180' : ''}`}></i>
                    </button>
                    
                    {showLandscapingMenu && (
                      <div className="absolute bottom-full left-0 mb-2 bg-white rounded-lg shadow-lg border border-gray-100 py-2 min-w-[200px] z-10">
                        {landscapingServices.map((item, idx) => (
                          <button
                            key={idx}
                            className="w-full px-4 py-2.5 text-left text-sm text-gray-700 hover:bg-teal-50 hover:text-teal-600 transition-colors flex items-center gap-3 cursor-pointer"
                          >
                            <i className={`${item.icon} text-teal-500`}></i>
                            {item.name}
                          </button>
                        ))}
                      </div>
                    )}
                  </div>
                )}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
